import * as React from 'react';
import {useDispatch} from 'react-redux';

import {MODAL_NOTIFICATION_PERMISSION} from '~/rootStore/modals/modalsIds';
import useModalById from '~/customHooks/useModalById';
import {logEvent} from '~/modules/App/store/gaActions';
import localStorageWrapper from '~/utils/localStorageWrapper';
import {requestNotificationsPermissionsAction} from '~/modules/CurrentUser/store/actions';

import ModalBaseContent from '../ModalBaseContent';
import ModalBase from '../ModalBase';
import image from './img/allow-location-icon.svg';

const ModalAllowNotifications: React.FC = () => {
  const {isOpen, close: closeAllowNotificationModal} = useModalById(MODAL_NOTIFICATION_PERMISSION);
  const dispatch = useDispatch();

  const handleActionClick = async () => {
    await dispatch(requestNotificationsPermissionsAction());
    closeAllowNotificationModal();
    localStorageWrapper.setItem(MODAL_NOTIFICATION_PERMISSION, 'true');
    logEvent({
      category: 'permission-modal',
      action: 'show-modal',
    });
  };

  return (
    <ModalBase open={isOpen} onClose={closeAllowNotificationModal}>
      <ModalBaseContent
        p={2}
        image={image}
        title="Allow Notification receive"
        description="To get notifications when receiving new messages, you need to accept notification request made by application"
        actionButtonText="OK"
        onClickActionButton={handleActionClick}
      />
    </ModalBase>
  );
};

export default ModalAllowNotifications;
